import {IRoutableModule} from '../../router/routing.infra';
import {HistoryView} from './history.view';
import {historyRouteLoader} from './history.loader';

export default {
    loader: historyRouteLoader,
    Component: HistoryView,
    storeAs: 'historyStore'
} as IRoutableModule;
